import HeroImage from "../HeroImage";

export default function ForgotPasswordImage() {
    return (
        <HeroImage imageUrl="/img/photo_3.webp" paragraph="Reset your password and experience the most sophisticated wind and weather measurement and analytics on the market." />
    )
}